import { Currency } from "macguffin"

import SummaryLine from "./SummaryLine"

import BackgroundImage from "utils/BackgroundImage"

export default class JackpotLine extends SummaryLine {
    render() {
        const { props, state } = this
        const { jackpotStyle, valueStyle } = props
        const { value, summaryFormat } = state

        return <div className="summaryLine">
            <BackgroundImage className="jackpotSummaryLogo" assetName={"marsSummaryJackpot"} style={jackpotStyle}/>
            <h1 style={valueStyle}>
                {Currency.format(value, summaryFormat)}
            </h1>
        </div>
    }
}
